module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.orderSummaryInfo) ? _c('ol', {
    staticClass: "px-8 py-2 fontS14"
  }, _vm._l((_vm.orderSummaryInfo.details), function(product) {
    return _c('li', {
      key: product.id,
      staticClass: "py-2 fontAvenirBold"
    }, [_c('div', {
      staticClass: "d-flex wrap space-between"
    }, [_c('div', {
      staticClass: "flex-50"
    }, [_c('span', [_vm._v(_vm._s(product.description))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-50 d-flex space-between"
    }, [_c('span', {
      staticClass: "fontAvenir"
    }, [_vm._v("Cantidad: " + _vm._s(product.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "fontS16 product-price"
    }, [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(product.salePrice)))])])])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dde96cce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy/orderedProducts.vue
// module id = 1161
// module chunks = 52